import styled, { css } from 'styled-components';

type CheckButtonProps = {
  isSelected?: boolean;
};

export const CheckButton = styled.button.attrs({
  type: 'button',
})<CheckButtonProps>`
  margin-bottom: 0.5rem;
  background: transparent;

  display: flex;

  align-items: center;

  .radio {
    width: 2.2rem;
    height: 2.2rem;
    background: #fff;

    border: 1px solid #000;
    border-radius: 0.4rem;
  }

  .filled {
    width: 100%;
    height: 100%;
    border: 1px solid #fff;
    border-radius: 0.4rem;

    background: ${({ isSelected }) => (isSelected ? '#000' : false)};
  }

  p {
    color: #000;

    font-size: 1.8rem;
    padding: 0 0.5rem;
    text-transform: capitalize;
  }

  :active {
    filter: opacity(0.8);
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;

  h1 {
    margin-bottom: 2rem;
  }

  .profile-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
  }

  .sheet-model {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h3 {
      color: #00000080;
    }
  }
`;

export const MuscleGroupContainer = styled.div`
  margin: 4rem;
  margin-top: 0;
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem 5rem;
  margin-bottom: 2rem;
`;

export const RowContent = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

export const ModalButton = styled.button.attrs({ type: 'button' })`
  color: #fff;
  font-size: 2.4rem;
  font-weight: bold;

  width: 100%;
  height: 5.8rem;
  background: transparent
    linear-gradient(96deg, var(--unnamed-color-000000) 0%, #232323 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(96deg, #000000 0%, #232323 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 5rem;
  opacity: 1;
`;

export const PageHeader = styled.div`
  padding: 3.8rem 5.6rem;
  height: 12rem;

  display: flex;
  flex-direction: column;
  justify-content: center;

  background: #242424;

  @media (max-width: 1024px) {
    padding: 2rem 4rem;
  }

  @media (max-width: 425px) {
    padding: 2rem;
  }
`;

type HeaderWrapperProps = {
  secondary?: boolean;
};

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  @media (max-width: 1024px) {
    flex-wrap: wrap;
  }
  width: 100%;

  @media (max-width: 768px) {
    display: flex;
  }

  @media (max-width: 1024px) {
    width: 100%;
    display: flex;
    align-items: center;

    flex-direction: row;
    justify-content: space-between;

    ${({ secondary }) =>
      secondary &&
      css`
        flex-direction: column;
        align-items: flex-start;
      `}
  }
`;

export const PageHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  font-size: 25px;
  align-items: center;
  justify-content: space-between;
  color: #ffdf22;
  width: 100%;

  svg {
    cursor: pointer;
  }

  letter-spacing: 1.25px;

  @media (max-width: 1024px) {
    width: 48%;
  }
  @media (max-width: 425px) {
    width: fit-content;
  }
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 425px) {
    display: none;
  }
`;

type InfoProps = {
  hide?: boolean;
};

export const InfoButton = styled.button<InfoProps>`
  background: transparent;
  font-size: 0;

  transition: filter 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const Info = styled.div`
  display: flex;
  margin-top: 1.4rem;

  @media (max-width: 1024px) {
    margin-top: 0rem;
  }

  /* @media (max-width: 1024px) {
    width: 48%;
  } */

  @media (max-width: 425px) {
    width: fit-content;
  }
`;

export const InfoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.8rem;
  margin-right: 3rem;

  p {
    margin-left: 0.4rem;
  }
`;

export const Container = styled.div`
  flex: 1;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;

  height: 80%;

  > h1 {
    color: #ffdf22;
  }
`;

export const Card = styled.div`
  position: relative;
  width: fit-content;
  background: #ffffff;
  border-radius: 0.4rem;

  cursor: pointer;

  @media (max-width: 768px) {
    width: fit-content;
  }

  display: flex;
  flex-direction: column;

  padding: 2rem 2.9rem;
`;

export const Options = styled.div`
  position: absolute;
  right: 3%;
  top: 15%;

  background: none;

  z-index: 99;
  cursor: pointer;

  > svg {
    &:hover {
      background: #dadada;
      border-radius: 50%;
    }
  }

  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;

    position: absolute;
    left: -10rem;
    overflow: hidden;

    width: 14rem;

    background: #ffffff;

    box-shadow: 0px 0px 4px #40404030;
    border-radius: 2px;

    opacity: 0;

    transition: 300ms ease-in-out;
    pointer-events: none;

    .divider {
      height: 1px;
      background: #cbcbcb;
      margin: 0 0.3rem;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      background: #ffffff;
      height: 4rem;
      border-radius: 0;

      color: #0f0f0f;
      font-size: 1.4rem;
      font-family: ${({ theme }) => theme.fontFamily.Nunito};
      font-weight: 600;
      line-height: 1.9rem;

      :last-child {
        color: #d90606;
      }

      &:hover {
        background: #40404030;
      }
    }
  }

  &:hover {
    > div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;

export const CardText = styled.p`
  font-size: 1.8rem;
  padding-right: 2rem;

  strong {
    text-transform: uppercase;
  }
`;

export const DeleteDivisionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    width: 80%;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      border-radius: 50px;
      opacity: 1;

      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;

export const Section = styled.section`
  margin: 3.8rem 5.8rem;

  display: flex;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;
